import { dataFolderOpen } from 'dls-icons-data'
import { createIcon } from '../common'

const IconFolderOpen = /*#__PURE__*/createIcon(dataFolderOpen)
export default IconFolderOpen
